import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

/** Keep in sync with backend GAUGING_MODELS / GAUGING_VERBOSITIES. */
export const GAUGING_MODELS = [
  'gpt-5',
  'gpt-5.1',
  'gpt-5.6-terra',
] as const;

export const GAUGING_VERBOSITIES = ['high', 'medium'] as const;

export type GaugingModel = (typeof GAUGING_MODELS)[number];
export type GaugingVerbosity = (typeof GAUGING_VERBOSITIES)[number];

/** Keep in sync with backend MODE_TO_MODEL_MAP["matter_memory" / "early_case_assessment"]. */
export const DEFAULT_GAUGING_MODEL: GaugingModel = 'gpt-5';
/** Keep in sync with backend MatterMemoryService verbosity default ("high"). */
export const DEFAULT_GAUGING_VERBOSITY: GaugingVerbosity = 'high';

interface ModelVerbosityPickerProps {
  model: GaugingModel;
  verbosity: GaugingVerbosity;
  onModelChange: (model: GaugingModel) => void;
  onVerbosityChange: (verbosity: GaugingVerbosity) => void;
  disabled?: boolean;
}

export function ModelVerbosityPicker({
  model,
  verbosity,
  onModelChange,
  onVerbosityChange,
  disabled = false,
}: ModelVerbosityPickerProps) {
  return (
    <div className="grid grid-cols-2 gap-3 py-2">
      <div className="space-y-1.5">
        <Label className="text-xs font-medium text-slate-600">Model</Label>
        <Select
          value={model}
          onValueChange={(value) => onModelChange(value as GaugingModel)}
          disabled={disabled}
        >
          <SelectTrigger className="h-9 text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {GAUGING_MODELS.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs font-medium text-slate-600">Verbosity</Label>
        <Select
          value={verbosity}
          onValueChange={(value) => onVerbosityChange(value as GaugingVerbosity)}
          disabled={disabled}
        >
          <SelectTrigger className="h-9 text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {GAUGING_VERBOSITIES.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
